import type { GenieKnowledgeEntry } from '../../types';

export const plexopathy: GenieKnowledgeEntry = {
  id: 'plexopathy',
  aliases: ['brachial_plexopathy'],
  name: 'Plexopatía',
  category: 'neuropatico',
  conversation: {
    headline:
      'Lesión del plexo braquial o lumbosacro. Patrón regional asimétrico que no respeta un solo miótoma o nervio.',
    edxHighlights: [
      'Afectación de múltiples nervios/raíces en región anatómica del plexo',
      'EMG en músculos de diferentes raíces pero misma región',
      'NCS: amplitudes reducidas en varios nervios del plexo',
      'Parsonage-Turner: dolor severo → debilidad (neuralgia amiotrófica)',
    ],
    pearls: [
      'Diferenciar de radiculopatía múltiple: plexopatía respeta región del plexo.',
      'Amiotrofia diabética lumbosacra: plexopatía autoinmune, no isquemia simple.',
    ],
    differentials: [
      { name: 'Radiculopatía múltiple', distinguishingHint: 'distribución miótomal estricta' },
      { name: 'Mononeuropatía múltiple', distinguishingHint: 'nervios individuales sin patrón plexual' },
    ],
    nextSteps: [
      'Mapear distribución con EMG en músculos de distintas raíces del plexo',
      'RM de plexo si masa, trauma o sospecha neoplásica',
    ],
  },
  orientationHints: {
    temporalFit: ['acute', 'subacute', 'chronic'],
    whenToSuspect: 'Debilidad/dolor regional asimétrico tras trauma, radiación o infección',
  },
};
